import {
	createFileRoute,
	Outlet,
	redirect,
	useLocation,
	useNavigate,
	useParams,
} from "@tanstack/react-router";
import z from "zod";
import { PageHeader } from "@/components/Organisms/PageHeader/PageHeader";
import { PageLayout } from "@/components/Organisms/PageLayout/PageLayout";
import { useAppTranslation } from "@/hooks/use-app-translation";
import { ViewTransitionTypes, viewTransition } from "@/utils/view-transitions";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/activity/logs",
)({
	component: RouteComponent,
	beforeLoad: ({ params, location }) => {
		if (
			location.pathname === `/org-admin/${params.orgId}/activity/logs` ||
			location.pathname === `/org-admin/${params.orgId}/activity/logs/`
		) {
			console.log("Redirecting to org logs");
			// Redirect to default tab (org logs)
			throw redirect({
				to: "/org-admin/$orgId/activity/logs/orgLogs",
				params: {
					orgId: params.orgId,
				},
				replace: true,
				...viewTransition(ViewTransitionTypes.FADE),
			});
		}
	},
	validateSearch: (search) => {
		return z
			.object({
				create: z.enum(["userLogs", "orgLogs"]).optional(),
			})
			.parse(search);
	},
});

function RouteComponent() {
	const { t } = useAppTranslation();
	const navigate = useNavigate();

	const params = useParams({
		from: "/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/activity/logs",
	});

	const location = useLocation();

	const currentTab = location.pathname.includes("/userLogs")
		? "userLogs"
		: "orgLogs";

	const tabs = [
		{ label: t("admin.nav.items.activity.logs.orgLogs.label"), id: "orgLogs" },
		{
			label: t("admin.nav.items.activity.logs.userLogs.label"),
			id: "userLogs",
		},
	];

	return (
		<PageLayout
			header={
				<PageHeader
					type="landing"
					title={t("org-admin.logs.table.title")}
					description={t("org-admin.logs.table.description")}
					showTabs
					tabs={tabs}
					selectedTabId={currentTab}
					onTabChange={(chosen) => {
						navigate({
							to: `/org-admin/$orgId/activity/logs/${chosen}`,
							params: {
								orgId: params.orgId,
							},
							...viewTransition(ViewTransitionTypes.FADE),
						});
					}}
				/>
			}
		>
			<Outlet />
		</PageLayout>
	);
}
